import React from 'react'
import { Button } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import questionSelectors from '../../../../../../store/selectors/question.selectors'
import ChangesHistoryDrawer from './ChangesHistoryDrawer'
import { questionActions } from '../../../../../../store/slices/question.slice'

const ChangesHistoryButton = () => {
    const showChangesHistoryDrawer = useSelector(questionSelectors.showChangesHistoryDrawer)
    const dispatch = useDispatch()

    const handleOpenDrawer = () => dispatch(questionActions.setShowChangesHistoryDrawer(true))

    return (
        <>
            <Button icon={<ClockCircleOutlined />} type='text' onClick={handleOpenDrawer}>
                Changes history
            </Button>
            {showChangesHistoryDrawer && <ChangesHistoryDrawer />}
        </>
    )
}

export default ChangesHistoryButton
